import { useQuery } from '@tanstack/react-query';
import { useServices } from '@/shared/hooks/use-services';
import { useAuth } from '@/modules/auth/hooks/use-auth';

export const CLUB_SUMMARY_KEY = 'club-summary';

/**
 * Resumo do Clube da loja. A chave inclui o estado de login porque a mesma
 * rota responde com ou sem os dados do cliente conforme o token.
 */
export function useClubSummary(slug: string, options?: { enabled?: boolean }) {
  const { getClubSummary } = useServices();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: [CLUB_SUMMARY_KEY, slug, isAuthenticated],
    queryFn: () => getClubSummary.execute({ slug }),
    enabled: (options?.enabled ?? true) && !!slug,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
}
